export default "__VITE_ASSET__DJVeAVnW__"